import { getUrlBase } from '../../../utils/general'
import { checkPermissionLevel, setPermissions } from './utils'

// module permissions controls actions (view, edit, delete) inside modules
export const setModulePermissions = ({ agentPermissions, isAgentOwnership, isAgentOffice, module, action, permissionName }) => {
    // diary tables don't have checkboxes for permissions to control
    if (module === 'intermediary-diary' || module === 'evidence-diary') {
        return { hasModulePermission: true }
    }

    const { permission, name: actionName } = action ?? {}

    let hasModulePermission = false
    const moduleName = getUrlBase(module)

    permissionName = permissionName ?? `module.${moduleName}.${permission}`

    switch (permission) {
        case 'view':
        case 'edit':
            hasModulePermission = setPermissions(agentPermissions, permissionName, isAgentOwnership, isAgentOffice, module, actionName)
            break
        case 'delete': {
            const fallbackPermission = `module.${moduleName}.edit`
            const hasDeletePermission = checkPermissionLevel(agentPermissions, permissionName) !== null

            hasModulePermission = setPermissions(
                agentPermissions,
                hasDeletePermission ? permissionName : fallbackPermission,
                isAgentOwnership,
                isAgentOffice,
                module,
                actionName
            )
            break
        }
        default:
            break
    }

    return { hasModulePermission }
}
